export default __webpack_public_path__ + "assets/bob-w-logo-face.c61b73071f03790beb39e505c4abc28d.svg";